export default function guest({ next, from, store }) {

    if (store.state.auth.isLoggedIn) next('/')

    else next()

}